/**
 * t471u: the phone person sheet's "Delete permanently", for workspace Owners on people already deactivated (the
 * profile's can.delete_permanently; the API checks again). Opens a bottom sheet (swipe down to close, no ✕) with the
 * same wording and name check as the desktop dialog and the iOS app.
 */
import { useState } from 'react';
import { MEMBER_DELETE_TEXT as T, type PersonProfile } from '@tradeoutlet/shared';
import { useWorkspaceId } from '@/lib/hooks';
import { BottomSheet } from '@/mobile/BottomSheet';
import { DeleteMemberBody, DeleteMemberButtons, useDeleteMember } from '@/features/people/users/DeleteMember';

export function PersonDeleteMember({ p, onDeleted }: { p: PersonProfile; onDeleted: () => void }) {
  const ws = useWorkspaceId();
  const [open, setOpen] = useState(false);
  const s = useDeleteMember(ws, p.user_id, p.display_name, () => { setOpen(false); onDeleted(); });
  if (!p.can.delete_permanently || p.is_me) return null;
  const close = () => { if (s.busy) return; s.reset(); setOpen(false); };
  return (
    <section className="border-t border-slate-100 py-3 dark:border-slate-800" data-testid="person-delete">
      <div className="mx-5 overflow-hidden rounded-xl border border-slate-200 dark:border-slate-700">
        <button type="button" onClick={() => setOpen(true)} data-testid="delete-member-open"
          className="flex min-h-[48px] w-full items-center px-4 text-left text-base text-rose-600 active:bg-slate-100 dark:active:bg-slate-800">
          {T.button}
        </button>
      </div>
      <BottomSheet open={open} onClose={close} title={T.title(p.display_name)} testId="delete-member-sheet"
        footer={<DeleteMemberButtons s={s} onCancel={close} full />}>
        <div className="px-4 pb-2"><DeleteMemberBody name={p.display_name} s={s} /></div>
      </BottomSheet>
    </section>
  );
}
